/**
 * Encapsulates parameters used to make requests to [PartnerService].
 */
export class BrandingPartnersRequest {
  public static readonly instance = new BrandingPartnersRequest()
}
